var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"profiles"},[(_vm.profiles.length)?_c('Cards',{attrs:{"type":"profiles","min-width":"320px","per-row":"2","md-per-row":"2","sm-per-row":"1"}},_vm._l((_vm.profiles),function(profile){return _c('ProfileCard',{key:profile.Id,attrs:{"profile":profile}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }